import type { IdentityLookupParams, IdentityLookupResponse } from '../api/identityVerificationDashboardApi';

export type IdentityLookupFn = (params: IdentityLookupParams) => Promise<IdentityLookupResponse>;

/**
 * Resolve identity lookup rows for an application, mirroring orchestrator journey
 * snapshot fallbacks when sessions are linked by CCID instead of application_id.
 */
export async function resolveIdentityLookupForApplication(
  params: {
    applicationId: string;
    ccid?: string | null;
  },
  lookup: IdentityLookupFn,
): Promise<IdentityLookupResponse> {
  const applicationId = params.applicationId.trim();
  const byApplication = await lookup({ applicationId });
  if (byApplication.items.length > 0) {
    return byApplication;
  }

  const ccid = params.ccid?.trim();
  if (!ccid) {
    return byApplication;
  }

  return lookup({ ccid });
}
